import script from "./Page7.vue?vue&type=script&setup=true&lang=js"
export * from "./Page7.vue?vue&type=script&setup=true&lang=js"

import "./Page7.vue?vue&type=style&index=0&id=7f590196&lang=less"

const __exports__ = script;

export default __exports__